import styles from '../Tabs/Tabs.module.css';

export type SectionLink<Id extends string> = { readonly id: Id; readonly label: string };

export type SectionNavProps<Id extends string> = {
  label: string;
  sections: readonly SectionLink<Id>[];
  current: Id;
  onSelect: (id: Id) => void;
};

export const SectionNav = <Id extends string>({
  label,
  sections,
  current,
  onSelect,
}: SectionNavProps<Id>) => (
  <nav aria-label={label} className={styles['list']}>
    {sections.map((section) => (
      <button
        key={section.id}
        type="button"
        aria-current={section.id === current ? 'page' : undefined}
        className={[styles['tab'], section.id === current ? styles['active'] : ''].join(' ')}
        onClick={() => {
          onSelect(section.id);
        }}
      >
        {section.label}
      </button>
    ))}
  </nav>
);
